module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('v-layout', {
    attrs: {
      "column": ""
    }
  }, [_c('v-flex', [_c('v-container', {
    attrs: {
      "fluid": "",
      "grid-list-md": ""
    }
  }, [_c('div', {
    staticClass: "primary"
  }, [_c('v-subheader', {
    staticClass: "deliverable",
    staticStyle: {
      "height": "85px"
    }
  }, [_c('img', {
    staticStyle: {
      "max-width": "8ex",
      "max-height": "8ex"
    },
    attrs: {
      "src": "/static/img/official_icons/deliverable.png"
    }
  }), _vm._v(" "), _c('h1', {
    staticClass: "deliverable",
    staticStyle: {
      "color": "white",
      "psition": "relative",
      "bottom": "10px"
    }
  }, [_vm._v("Document Library\n      ")])])], 1), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "append-icon": "search",
      "box": "",
      "placeholder": "Search a library..."
    },
    model: {
      value: (_vm.search),
      callback: function($$v) {
        _vm.search = $$v
      },
      expression: "search"
    }
  }), _vm._v(" "), _c('v-switch', {
    attrs: {
      "label": "Filter By Tag"
    },
    model: {
      value: (_vm.final),
      callback: function($$v) {
        _vm.final = $$v
      },
      expression: "final"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.final),
      expression: "final"
    }],
    attrs: {
      "items": _vm.tags,
      "box": "",
      "chips": "",
      "color": "blue-grey lighten-2",
      "label": "Select Tags to Filter By",
      "item-text": "name",
      "item-value": "name",
      "multiple": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          staticClass: "chip--select-multi",
          attrs: {
            "selected": data.selected,
            "close": ""
          },
          on: {
            "input": function($event) {
              data.parent.selectItem(data.item)
            }
          }
        }, [_vm._v("\n                              " + _vm._s(data.item) + "\n                            ")])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
          domProps: {
            "textContent": _vm._s(data.item)
          }
        })] : [_c('v-list-tile-content', [_c('v-list-tile-title', {
          domProps: {
            "innerHTML": _vm._s(data.item)
          }
        })], 1)]]
      }
    }]),
    model: {
      value: (_vm.tagFilters),
      callback: function($$v) {
        _vm.tagFilters = $$v
      },
      expression: "tagFilters"
    }
  }), _vm._v(" "), _c('v-layout', {
    staticClass: "scroll-y",
    attrs: {
      "row": "",
      "wrap": "",
      "id": "scroll-target"
    }
  }, _vm._l((_vm.searchedFiles), function(file) {
    return _c('v-flex', _vm._b({
      directives: [{
        name: "scroll",
        rawName: "v-scroll:#scroll-target",
        arg: "#scroll-target"
      }],
      key: file.fileURL,
      attrs: {
        "align-center": "",
        "justify-center": ""
      }
    }, 'v-flex', ( _obj = {}, _obj["xs3"] = true, _obj ), false), [_c('v-card', {
      staticStyle: {
        "height": "19em",
        "max-width": "260px",
        "min-width": "200px"
      },
      attrs: {
        "color": "grey lighten-2"
      }
    }, [_c('v-card-title', {
      attrs: {
        "primary-title": ""
      }
    }, [(file.title.length < 14) ? _c('h4', {
      staticClass: " headline mb-0",
      staticStyle: {
        "display": "block"
      }
    }, [_c('h3', {
      staticClass: " headline mb-0"
    }, [_vm._v(_vm._s(file.title))]), _vm._v(" "), _c('br'), _vm._v(" "), (file.tags.length !== 0) ? _c('h5', [_vm._v("Tags: "), _vm._l((file.tags), function(tag) {
      return [_c('h5', {
        key: tag,
        staticStyle: {
          "font-size": "13px"
        }
      }, [_vm._v(_vm._s(tag) + " ")])]
    })], 2) : _vm._e()]) : _vm._e(), _vm._v(" "), (file.title.length > 14) ? _c('h4', {
      staticClass: " headline mb-0",
      staticStyle: {
        "display": "block"
      }
    }, [_c('h3', {
      staticClass: " headline mb-0"
    }, [_vm._v(_vm._s(file.title.substring(0, 14)) + "...")]), _vm._v(" "), _c('br'), _vm._v(" "), (file.tags.length !== 0) ? _c('h5', [_vm._v("Tags: "), _vm._l((file.tags), function(tag) {
      return [_c('h5', {
        key: tag,
        staticStyle: {
          "font-size": "13px"
        }
      }, [_vm._v(_vm._s(tag) + " ")])]
    })], 2) : _vm._e()]) : _vm._e()]), _vm._v(" "), _c('v-card-actions', {
      staticStyle: {
        "position": "absolute",
        "bottom": "0px"
      }
    }, [_c('v-btn', {
      attrs: {
        "color": "green",
        "dark": ""
      },
      on: {
        "click": function($event) {
          this.window.open(file.fileURL)
        }
      }
    }, [_vm._v("\n            Open\n          ")]), _vm._v(" "), (file.projectID !== 0) ? _c('v-btn', {
      attrs: {
        "color": "primary",
        "dark": ""
      },
      on: {
        "click": function($event) {
          _vm.funct(file.projectID)
        }
      }
    }, [_vm._v("\n            Go to Project\n          ")]) : _vm._e(), _vm._v(" "), _c('v-dialog', {
      model: {
        value: (file.fileDialog),
        callback: function($$v) {
          _vm.$set(file, "fileDialog", $$v)
        },
        expression: "file.fileDialog"
      }
    }, [(file.delete === true) ? _c('v-btn', {
      attrs: {
        "slot": "activator",
        "color": "alerts",
        "dark": ""
      },
      slot: "activator"
    }, [_vm._v("\n            Delete\n          ")]) : _vm._e(), _vm._v(" "), _c('v-card', {
      staticStyle: {
        "width": "100%",
        "height": "150px"
      }
    }, [_c('v-card-title', [_c('h2', [_vm._v(" You want to delete the File: " + _vm._s(file.title) + "?")])]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "alerts",
        "flat": "",
        "dark": ""
      },
      on: {
        "click": function($event) {
          _vm.deletes(file)
        }
      }
    }, [_vm._v("\n                    Delete\n                  ")]), _vm._v(" "), _c('v-btn', {
      attrs: {
        "color": "green",
        "flat": "",
        "dark": ""
      },
      on: {
        "click": function($event) {
          file.fileDialog = false
        }
      }
    }, [_vm._v("\n                    Cancel\n                  ")])], 1)], 1)], 1)], 1)], 1)
    var _obj;
  }))], 1)], 1), _vm._v(" "), _c('input', {
    staticStyle: {
      "display": "none"
    },
    attrs: {
      "type": "file",
      "id": "selectedFile",
      "name": "fileName",
      "value": "fileName"
    },
    on: {
      "change": _vm.imageSelected
    }
  }), _vm._v(" "), _c('v-dialog', {
    model: {
      value: (_vm.dialog),
      callback: function($$v) {
        _vm.dialog = $$v
      },
      expression: "dialog"
    }
  }, [_c('v-btn', {
    attrs: {
      "slot": "activator",
      "color": "primary",
      "onclick": "document.getElementById('selectedFile').click();"
    },
    slot: "activator"
  }, [_vm._v("\n            Upload Document\n          ")]), _vm._v(" "), _c('v-card', {
    staticClass: "deliverable pa-3 ma-3",
    staticStyle: {
      "height": "300px"
    }
  }, [_c('v-subheader', [_c('h1', {
    staticStyle: {
      "color": "white"
    }
  }, [_vm._v(" Upload A Document ")])]), _vm._v(" "), _c('br'), _vm._v(" "), _c('h1', [_vm._v(_vm._s(_vm.fileName))]), _vm._v(" "), _c('v-text-field', {
    attrs: {
      "label": "Document Title",
      "required": ""
    },
    model: {
      value: (_vm.fileTitle),
      callback: function($$v) {
        _vm.fileTitle = $$v
      },
      expression: "fileTitle"
    }
  }), _vm._v(" "), _c('v-autocomplete', {
    attrs: {
      "items": _vm.tags,
      "box": "",
      "chips": "",
      "color": "blue-grey lighten-2",
      "label": "Select Tags for your Document",
      "item-text": "name",
      "item-value": "name",
      "multiple": ""
    },
    scopedSlots: _vm._u([{
      key: "selection",
      fn: function(data) {
        return [_c('v-chip', {
          staticClass: "chip--select-multi",
          attrs: {
            "selected": data.selected,
            "close": ""
          },
          on: {
            "input": function($event) {
              data.parent.selectItem(data.item)
            }
          }
        }, [_vm._v("\n                  " + _vm._s(data.item) + "\n                ")])]
      }
    }, {
      key: "item",
      fn: function(data) {
        return [(typeof data.item !== 'object') ? [_c('v-list-tile-content', {
          domProps: {
            "textContent": _vm._s(data.item)
          }
        })] : [_c('v-list-tile-content', [_c('v-list-tile-title', {
          domProps: {
            "innerHTML": _vm._s(data.item)
          }
        })], 1)]]
      }
    }]),
    model: {
      value: (_vm.tag),
      callback: function($$v) {
        _vm.tag = $$v
      },
      expression: "tag"
    }
  }), _vm._v(" "), _c('v-btn', {
    staticClass: "green",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.newFileTime()
      }
    }
  }, [_vm._v("Submit ")]), _vm._v(" "), _c('v-btn', {
    staticClass: "primary",
    staticStyle: {
      "color": "white"
    },
    attrs: {
      "flat": ""
    },
    on: {
      "click": function($event) {
        _vm.dialog = false
      }
    }
  }, [_vm._v("Cancel ")])], 1)], 1)], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-5443c411","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/Library.vue
// module id = 90
// module chunks = 10